import { useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Box, Flex, Button } from "@chakra-ui/react";
import { useBabyStation } from "src/modules/baby-station/BabyStation/Context";
import NoiseSensitivitySelector from "src/modules/station/components/NoiseSensitivitySelector";
import { getMicSensitivity } from "src/modules/baby-station/duck/selectors";
import { BodyText2 } from "src/atoms/typography";
import NoiseIndicator from "src/modules/station/components/NoiseIndicator";
import Modal from "src/components/Modal";
import IconAsButton from "src/components/IconAsButton";
import NoiseSensitivityCorrection from "./NoiseSensitivityCorrection";
import { ReactComponent as AdjustIcon } from "./adjust.svg";

export default function BabyStationNoiseSensitivty({ isOpen, onClose }) {
  const { t } = useTranslation();
  const babyStation = useBabyStation();
  const micSensitivity = useSelector(getMicSensitivity);

  const [sensitivityCorrection, setSensitivityCorrection] = useState({
    isOpen: false,
    open: () =>
      setSensitivityCorrection((prevState) => ({ ...prevState, isOpen: true })),
    close: () =>
      setSensitivityCorrection((prevState) => ({ ...prevState, isOpen: false }))
  });
  const { handleMicSensitivityChange, noiseMeter } = babyStation;
  return (
    <Modal isOpen={isOpen}>
      <Box width="280px">
        <Box pt="24px" px="24px" position="relative">
          <NoiseSensitivityCorrection
            isOpen={sensitivityCorrection.isOpen}
            onClose={sensitivityCorrection.close}
            anchor={
              <Box position="absolute" top="24px" right="24px">
                <IconAsButton
                  onClick={sensitivityCorrection.open}
                  icon={AdjustIcon}
                  size="20px"
                  fill="mediumEmphasis"
                />
              </Box>
            }
            noiseMeter={noiseMeter}
          />

          <NoiseSensitivitySelector
            selected={micSensitivity}
            onChange={handleMicSensitivityChange}
          />

          <BodyText2 mt="22px" mb="16px" color="mediumEmphasis">
            {t("noiseSensitivity.description")}
          </BodyText2>

          {noiseMeter && (
            <NoiseIndicator
              colorFirstTwoDots={true}
              noiseMeter={noiseMeter}
              station="baby"
              responsive={false}
            />
          )}
        </Box>
        <Flex mt="16px" pr="8px" pb="8px" justifyContent="flex-end">
          <Button
            variant="flatPrimary"
            onClick={onClose}
            minWidth="80px"
            mr="8px"
          >
            {t("buttons.cancel")}
          </Button>
          <Button variant="flatPrimary" onClick={onClose} minWidth="80px">
            {t("buttons.ok")}
          </Button>
        </Flex>
      </Box>
    </Modal>
  );
}
